import {ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy} from '@angular/router';

export class FrogRouteReuseStrategy implements RouteReuseStrategy {
    private storedRoutes = new Map<string, DetachedRouteHandle>();

    public reset(): void {
        this.storedRoutes.clear();
    }

    /**
     * Determines if this route (and its subtree) should be detached to be reused later
     * @param route
     */
    shouldDetach(route: ActivatedRouteSnapshot): boolean {
        if (route.routeConfig.path.startsWith('get-started/')) {
            this.reset();
            return false;
        }
        return route.routeConfig.path.startsWith('s/') || route.routeConfig.path.startsWith('v/');
    }

    /**
     * Stores the detached route.
     */
    store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
        this.storedRoutes.set(route.routeConfig.path, handle);
        if (route.routeConfig.path.startsWith('s/') || route.routeConfig.path.startsWith('v/')) {
            this.storedRoutes.set('main', handle);
        }
    }

    /**
     * Determines if this route (and its subtree) should be reattached
     * @param route Stores the detached route.
     */
    shouldAttach(route: ActivatedRouteSnapshot): boolean {
        if (route.routeConfig.path.startsWith('get-started/')) {
            this.reset();
            return false;
        }

        return !!route.routeConfig && !!this.retrieve(route);
    }

    /**
     * Retrieves the previously stored route
     */
    retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle {
        if (route.routeConfig.path.startsWith('s/') || route.routeConfig.path.startsWith('v/')) {
            return this.storedRoutes.get('main');
        }

        return this.storedRoutes.get(route.routeConfig.path);
    }

    /**
     * Determines if a route should be reused
     * @param future
     * @param current
     */
    shouldReuseRoute(future: ActivatedRouteSnapshot, current: ActivatedRouteSnapshot): boolean {
        return future.routeConfig === current.routeConfig;
    }
}
